<template>
  <div>
    <slot :openModal="openModal"></slot>
    <b-modal size="md" hide-header hide-footer v-model="showModal">

      <div v-if="state === 'loading'" class="tw-h-32 tw-flex tw-items-center tw-justify-center">
        Please wait...
      </div>

      <div v-else-if="state === 'success'" class="tw-flex tw-flex-col tw-gap-5 tw-items-center tw-py-8">
        <div class="tw-text-2xl tw-font-semibold">
          Data request sent!
        </div>

        <i class="far fa-check-circle fa-4x text-primary"></i>

        <div class="tw-px-16 tw-text-center">We received your request to download your data. It can take some time. We'll send you an email once the file is ready to be downloaded.</div>
      </div>

      <div v-else-if="state === 'error'">
        <div class="tw-flex tw-flex-col tw-gap-5 tw-items-center tw-py-8">
          <div class="tw-text-2xl tw-font-semibold">
            Error
          </div>

          <i class="far fa-times-circle fa-4x text-danger"></i>

          <div class="tw-px-16 tw-text-center">There was an error while creating the data request.</div>

          <button class="btn btn-primary btn-rounded" @click="handleIntercom">Contact Support</button>

        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

import GeneralMixins from "../../../mixins/GeneralMixins.js";
import {DownloadDataRequestsApi} from "../../Api/DownloadDataRequestsApi.js";

export default {
  mixins: [GeneralMixins],

  data() {
    return {
      showModal: false,
      state: "pending"
    }
  },

  methods: {
    handleIntercom() {
      if ('undefined' !== typeof Intercom) {
        Intercom('show')
      }
    },

    openModal() {
      this.showModal = true
      this.handleCreateDataRequest()
    },

    async handleCreateDataRequest() {
      this.state = "loading"
      try {
        await DownloadDataRequestsApi.create()
        this.state = "success"
      } catch (e) {
        console.log(e);
        this.state = "error"
        this.showErrorToast(this.getErrorMessages(e.body, true));
      }
    }
  },
}
</script>
